var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLike = function SvgLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 11,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.532 3.864H.633a.65.65 0 0 0-.448.174.58.58 0 0 0-.185.42v5.353c0 .315.133.618.37.84.238.224.56.349.896.349H1.9c.336 0 .658-.125.896-.348.237-.223.37-.526.37-.841V4.458a.58.58 0 0 0-.185-.42.65.65 0 0 0-.448-.174M10.734 3.864H8.23l.987-2.676a1 1 0 0 0-.17-.7A1.12 1.12 0 0 0 8.442.05a1.2 1.2 0 0 0-.764.027 1.1 1.1 0 0 0-.57.48 15 15 0 0 1-2.675 3.188v5.7h.072c1.335.347 3.103.96 4.74.96.886 0 1.007-.312 1.19-.783l1.49-4.163a1.12 1.12 0 0 0-.153-1.088 1.25 1.25 0 0 0-.453-.373 1.3 1.3 0 0 0-.584-.134"
  })));
};
export default SvgLike;